var map = {
	"./BACKGROUND0.png": "3fb3",
	"./COINS.png": "a326",
	"./VIDEO.png": "f3b4",
	"./bazar.png": "e641",
	"./chart.png": "dec2",
	"./check.png": "cbcd",
	"./edu.png": "87ee",
	"./global.png": "e743",
	"./gold.png": "831b",
	"./googleplay.png": "b830",
	"./iapps.png": "0d0e",
	"./iran.png": "ef34",
	"./next.png": "f2be",
	"./perv.png": "c57a",
	"./phonemockup.png": "32e1",
	"./restore.png": "1d77",
	"./sibapp.png": "6e50",
	"./slider.jpg": "28c8",
	"./slider2.jpg": "dade",
	"./slider3.jpg": "a483",
	"./tv.png": "fec7",
	"./user.png": "ea65",
	"./users.png": "0ead",
	"./wallet.png": "c3b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e5f";